export function parseAmount(amount) {
  if (typeof amount === "number") return amount;
  if (!amount) return 0;

  const suffix = amount.slice(-1).toLowerCase();
  const number = parseFloat(amount.slice(0, -1));

  if (Number.isNaN(number)) return 0;

  switch (suffix) {
    case "k":
      return number * 1000;
    case "m":
      return number * 1000000;
    case "b":
      return number * 1000000000;
    case "t":
      return number * 1000000000000;
    default:
      return parseFloat(amount) || 0;
  }
}
